import { makeObservable, observable, action } from 'mobx';

var UserWinBetsStore = /** @class */ (function () {
    function UserWinBetsStore() {
        this.userWiningBets = null;
        makeObservable(this, {
            userWiningBets: observable.deep,
            setUserWiningBets: action.bound,
        });
    }
    UserWinBetsStore.prototype.setUserWiningBets = function (bets) {
        this.userWiningBets = bets;
    };
    return UserWinBetsStore;
}());
var userWinCountStore = new UserWinBetsStore();

export { UserWinBetsStore, userWinCountStore };
